import React, { useContext, useEffect, useState } from "react";
import CustomerDetails from "./PvinCustomer";
import FleetSummary from "./FleetSummary";
import SubscriptionDetails from "./SubscriptionDetails";
import OffersSummary from "./OfferSummary";
import { getCustomerData } from "./pvinKpi";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { FilterContext } from "../../context/Filter";

const Dashboard = () => {
  const [customerDetails, setCustomerDetails] = useState(null);
  const [fleetSummary, setFleetSummary] = useState({});
  const [offerSummary, setOfferSummary] = useState({});
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const { open } = useContext(FilterContext);

  // const useQueryString = () => new URLSearchParams(useLocation().search);
  // const query = useQueryString();

  // // Helper to check if a value is valid
  // const isValid = (val) => val && val !== '""' && val !== "";

  // // Extract raw query values
  // const rawArn = query.get("arn");
  // const rawParArn = query.get("parArn");
  // const rawChildArn = query.get("childArn");

  // // Determine which ARN to use
  // let arnKey = null;
  // let arnValue = null;

  // if (isValid(rawArn)) {
  //   arnKey = "parArn";
  //   arnValue = rawArn;
  // } else if (isValid(rawChildArn)) {
  //   arnKey = "childArn";
  //   arnValue = rawChildArn;
  // } else if (isValid(rawParArn)) {
  //   arnKey = "parArn";
  //   arnValue = rawParArn;
  // }

  // const enabled = !!arnKey && !!arnValue;

  const { superArn: parArn, childArn } = useContext(FilterContext);

  const isValid = (val) => val && val !== '""' && val !== "";

  let arnKey = null;
  let arnValue = null;

  if (isValid(parArn)) {
    arnKey = "parArn";
    arnValue = parArn;
  }

  if (isValid(childArn)) {
    arnKey = "childArn";
    arnValue = childArn;
  }

  const enabled = !!arnKey && !!arnValue;

  const { data: customerDataValues } = useQuery({
    queryKey: ["getCustomerData", arnValue],
    queryFn: () => getCustomerData(arnKey, arnValue),
    enabled,
  });

  // console.log("customerDataValues", customerDataValues);
  // console.log("item", offerSummary);

  const firstItem = customerDataValues?.lastPurchaseDateModalAndFleetSize?.[0];
  const firstHit = firstItem?.account_info?.hits?.hits?.[0];

  const fleetSize = firstItem?.Fleet_size ?? "N/A";
  const lastPurchasedDate = firstHit?._source?.FIRST_SALE_DT_DATE ?? "N/A";
  const lastPurchasModel = firstHit?._source?.PL ?? "N/A";

  useEffect(() => {
    window.scrollTo(0, 0);

    setCustomerDetails(customerDataValues?.parData);
    setFleetSummary({
      Fleetsize: fleetSize?.doc_count,
      last_purchase_date_op: lastPurchasedDate?.split("T")?.[0],
      last_purchase_model_value: lastPurchasModel,
      purchase_qty_value: customerDataValues?.purchase_qty_value,
      last_six_month_value: customerDataValues?.last_six_month_value,
    });
    setOfferSummary(customerDataValues?.all_points?.Delight_and_Earned_Points);
    setSubscriptionDetails(customerDataValues?.ls_subs);
  }, [customerDataValues]);

  // console.log("fleetSummary", fleetSummary);

  return (
    <div>
      <div
        className={`block w-96 md:w-full   bg-gray-100 sm:p-2 mt-2  justify-center`}
      >
        <div
          className={`lg:grid sm:grid-cols-3  w-96 md:w-full   sm:flex sm:flex-col sm:gap-2`}
        >
          <CustomerDetails data={customerDetails} />
          <FleetSummary data={fleetSummary} />
          <div
            className={` ${open ? "w-[330px]" : "w-full"} flex flex-col gap-4`}
          >
            <OffersSummary data={offerSummary} />
            <SubscriptionDetails data={subscriptionDetails} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
